/* Service intent only. Native form submission and consent-aware attribution are unchanged. */
(function () {
  'use strict';
  if (window.BLNGStudioCommerce) return;
  window.BLNGStudioCommerce = true;
  var headings = {
    'shopify': 'Let’s build your Shopify store.',
    'prebuilt-store': 'Let’s find your store.',
    'custom-development': 'Let’s improve your Shopify store.',
    'migration': 'Let’s plan your store migration.',
    'klaviyo': 'Let’s plan your email marketing.',
    'paid-media': 'Let’s plan your paid media.',
    'google-ads': 'Let’s plan your Google Ads.',
    'meta-ads': 'Let’s plan your Meta Ads.',
    'pinterest-ads': 'Let’s plan your Pinterest Ads.',
    'seo': 'Let’s improve your search visibility.',
    'analytics': 'Let’s make your measurement clearer.',
    'ai-visibility': 'Let’s improve your visibility.'
  };
  function initialize(root) {
    root.querySelectorAll('[data-studio-inquiry]').forEach(function (scope) {
      if (scope.dataset.studioInquiryReady) return;
      scope.dataset.studioInquiryReady = 'true';
      var select = scope.querySelector('[data-studio-service]');
      if (!select) return;
      var params = new URLSearchParams(window.location.search);
      var slug = params.get('service') || scope.dataset.serviceDefault || '';
      var option = Array.from(select.options).find(function (item) {
        return item.dataset.serviceSlug === slug;
      });
      // Keep any server-restored choice after a validation error.
      if (option && !select.value) select.value = option.value;
      var requested = scope.querySelector('[data-studio-requested-service]');
      var tierField = scope.querySelector('[data-studio-requested-tier]');
      var tier = params.get('tier');
      var tiers = ['entry', 'launch', 'standard', 'complete', 'custom'];
      if (tierField && tiers.indexOf(tier) !== -1) tierField.value = tier;
      function update() {
        var selected = select.options[select.selectedIndex];
        var key = selected && selected.dataset.serviceSlug;
        if (requested) requested.value = key || '';
        var page = scope.closest('.studio-inquiry');
        if (!page) return;
        var heading = page.querySelector('[data-studio-inquiry-heading]');
        var context = page.querySelector('[data-studio-inquiry-context]');
        if (heading) {
          if (!heading.dataset.defaultHeading) heading.dataset.defaultHeading = heading.textContent;
          heading.textContent = headings[key] || heading.dataset.defaultHeading;
        }
        if (context) {
          context.hidden = !key;
          context.textContent = key ? 'Project focus: ' + selected.textContent + '.' : '';
        }
      }
      select.addEventListener('change', update);
      update();
    });
  }
  function start() { initialize(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
